import { City } from "app/pages/component/types/city/City";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getRegion = async (queryParams?:any) => {
  return await get<ApiResponse<City[]>>(`/region?${queryParams}`).then((res)=>{
        try{
                if(res?.success===true){
                    return res
                }
                else{
                    return null
                }
        }
        catch(e:any){
        
        }
  })
};
